import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/system-files/system-file/loading';

export const Route = createFileRoute('/_private/settings/system-files/$id')({
  pendingComponent: Loading,
});
